import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type { AppWaldenViewModel } from '../../walden-view';

export default class AppServicesWaldenViewRefIndexRoute extends Route {
  // IMPORTANT: Due to Ember's route inheritance, this duplication is necessary, otherwise this index will not resolve correctly.
  @service('router') declare routerService: RouterService;

  beforeModel() {
    const parentModel = this.modelFor(
      'app.services.walden-view-ref',
    ) as AppWaldenViewModel;
    if (parentModel.userCanAccessService && parentModel.pages) {
      this.routerService.transitionTo(
        'app.services.walden-view-ref.detail',
        parentModel.pages[0]?.routeName,
      );
    }
  }
}
